import translationEN from '../../locales/en/translation.json';
import translationFR from '../../locales/fr/translation.json';
import { initI18n } from '@jaam/web-core';

const getStoredLanguage = () => {
  return localStorage.getItem('UserLanguage')?.toLowerCase() || 'fr';
};

const i18n = initI18n({
  localEn: translationEN,
  localFr: translationFR,
  defaultNamespace: 'translation',
  lng: getStoredLanguage(),
});

// Add listener to save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
